import React from "react";
import { Box, Divider, IconButton, List, Stack, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import NextLink from "next/link";
import { menuItem } from "../Header/menuItem";
import SideMenuList from "./SideMenuList";
import useAuthProvider from "../../../store/AuthProvider";

interface SideMenuProps {
  isMobile: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function SideMenu({ setIsOpen, isMobile }: SideMenuProps) {
  const auth = useAuthProvider();

  const logoutHandler = () => {
    auth.logout();
    setIsOpen(false);
  };

  const filteredMenu = menuItem.filter((item) => {
    if (auth.isAuthenticated) {
      return !item.hideOnAuthenticate || item.isResctricted;
    }
    return !item.isResctricted;
  });

  return (
    <Box
      sx={{
        width: isMobile ? "80vw" : 360,
        maxWidth: 420,
        height: "100vh",
        background: (theme) => theme.palette.background.paper,
        color: "inherit",
        display: "flex",
        flexDirection: "column",
        boxShadow: "-12px 0 40px rgba(15, 23, 42, 0.25)",
        borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
        transform: "translateZ(0)",
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" px={3} py={2}>
        <Typography variant="h3" sx={{ fontWeight: 700 }}>
          Menu
        </Typography>
        <IconButton aria-label="Close navigation" onClick={() => setIsOpen(false)}>
          <CloseRoundedIcon fontSize="large" />
        </IconButton>
      </Stack>
      <Divider />
      <List sx={{ flexGrow: 1, py: 2 }}>
        {filteredMenu.map((item) => (
          <SideMenuList key={item.path} label={item.label} path={item.path} onClose={setIsOpen} />
        ))}
      </List>
      <Divider />
      <Stack spacing={2} px={3} py={3}>
        {auth.isAuthenticated ? (
          <Typography
            component="button"
            type="button"
            onClick={logoutHandler}
            sx={{
              background: "none",
              border: "none",
              color: "inherit",
              textAlign: "left",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
              padding: 0,
            }}
          >
            Log out
          </Typography>
        ) : (
          <Typography
            component={NextLink}
            href="/signin"
            sx={{
              fontWeight: 600,
              textDecoration: "none",
            }}
            onClick={() => setIsOpen(false)}
          >
            Sign in
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
